//import Echo from 'laravel-echo'
import Token from '@/services/token'

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js')

window.Echo = new Echo({
	broadcaster: 'pusher',
	key: process.env.VUE_APP_PUSHER_KEY,
	encrypted: true,
	cluster: process.env.VUE_APP_PUSHER_CLUSTER,
	authEndpoint: process.env.VUE_APP_API_URL + '/broadcasting/auth',
	auth: {
		headers: {
			Authorization: `Bearer ${Token.getToken()}`,
		},
	},
})